<template>
    <div class="adminUserList">
        <div class="row">
            <div class="col-md-5">
                <Breadcumb title="Catégories Forum" :breadcumb-data="breadcumbData">
                    <b-btn v-bind:to="'/dashboard/administration/forum/add/'" class="mt-3 mb-3" variant="primary" style="float:right">
                        Ajouter une catégorie
                    </b-btn>
                </Breadcumb>
            </div>
        </div>
        <b-card no-body class="cardcontainer">
            <b-card-body>
                <b-table
                        v-if="categoriesData"
                        :items="categoriesData"
                        :fields="fields"
                        :striped="true"
                        :bordered="true"
                        class="card-table">
                    
                    <template slot="Nom" slot-scope="data">
                        {{data.item.name}}
                    </template>
                    <template slot="Actions" slot-scope="data">
                        <b-btn v-bind:to="'/dashboard/administration/user/' + data.item.id" variant="default btn-xs icon-btn md-btn-flat"
                               v-b-tooltip.hover title="Profil"><i class="ion ion-md-person"></i></b-btn>
                        <b-btn v-on:click="deleteId= data.item.id; $refs.formodal.open()" variant="default btn-xs md-btn-flat">
                            <i class="ion ion-md-close"></i>
                        </b-btn>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
        <sweet-modal width="300px" ref="formodal" height="80%">
            <b-btn v-on:click="deleteUser(deleteId)" variant="danger md-btn-flat"
                   v-b-tooltip.hover title="Supprimer">Supprimer l'utilisateur</b-btn>
        </sweet-modal>
    </div>
</template>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>
<script>
    import {
        GET_CATEGORIES_REQUEST
    } from '../../_store/exchange/actiontypes';
    import Breadcumb from '../../components/breadcumb';
    import { mapState } from 'vuex';
    import {SweetModal, SweetModalTab} from 'sweet-modal-vue'

    export default {
        name: 'adminUserList',
        components: {Breadcumb, SweetModal, SweetModalTab},
        computed: mapState({ categoriesData: state => state.exchange.categories}),
        mounted() {
            this.$store.dispatch(GET_CATEGORIES_REQUEST)
        },
        methods: {
        },
        data() {
            return {
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Liste des catégories', active: true },
                ],
                fields: [
                    {
                        key: 'Nom',
                        sortable: false,
                        tdClass: 'align-middle'
                    },
                    {
                        key: 'Actions',
                        sortable: false,
                        tdClass: 'align-middle'
                    }
                ],
            };
        },
        layout(context) {
            return 'layout';
        },
    };
</script>
